// import { merge } from 'lodash';
import { buildCloudPayQuery } from '../utils/query';

/**
 * @description Get a transaction by order
 *
 * @param {Object} [options]
 * @returns {QueryConfig}
 */
export const getPaymentMethodsByUser = buildCloudPayQuery(
  ({ token }) => ({
    url: `/paymentMethods`,
    options: {
      authorization: 'Bearer ' + token
    },
    force: true,
    transform: userPaymentMethods => ({ userPaymentMethods }),
    update: {
      userPaymentMethods: (a1, a2) => {
        return [...a2]?.sort((a) => a.default ? -1 : 1);
      }
    }
  })
);

export const NewPaymenthMethodsToUser = buildCloudPayQuery(
  ({ token, methodId, paymentInfo }) => ({
    url: `/paymentMethods/${methodId}`,
    options: {
      authorization: 'Bearer ' + token,
      method: 'POST'
    },
    force: true,
    body: paymentInfo
  })
);

export const changeFavoritePaymentMethod = buildCloudPayQuery(
  ({ token, paymentMethod, id }) => ({
    url: `/paymentMethods/${paymentMethod}`,
    options: {
      authorization: 'Bearer ' + token,
      method: 'PATCH'
    },
    force: true,
    body: { id }
  })
);

export const deletePaymentMethodsToUser = buildCloudPayQuery(
  ({ token, paymentMethod, id }) => ({
    url: `/paymentMethods/${paymentMethod}`,
    options: {
      authorization: 'Bearer ' + token,
      method: 'DELETE'
    },
    force: true,
    body: { id },
    update: {
      userPaymentMethods: (userPaymentMethods) => {
        const newUserPaymentMethods = userPaymentMethods.filter(paymentMethod => paymentMethod._id !== id);
        return [...newUserPaymentMethods];
      }
    }
  })
);

/**
 * @description Get a transaction by order
 *
 * @param {Object} [options]
 * @returns {QueryConfig}
 */
export const getSubPaymentMethodsByClient = buildCloudPayQuery(({ token }) => ({
  url: `/client/payment/subPaymentMethods`,
  options: {
    authorization: 'Bearer ' + token,
  },
  force: true,
  transform: (subPaymentMethods) => {
    const subPaymentMethodsFilter = subPaymentMethods
      .filter(({ paymentMethod }) => paymentMethod !== 'affiliates')
      .map(
        ({
          subPaymentData,
          paymentMethod,
          active,
          clientShortCode,
          countryCode,
          createdAt,
        }) => ({
          paymentMethod,
          ...subPaymentData,
          active,
          clientShortCode,
          countryCode,
          createdAt,
        })
      );
    return { subPaymentMethods: subPaymentMethodsFilter };
  },
  update: {
    subPaymentMethods: (prev, updated) => updated,
  },
}));
